import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VHover } from 'vuetify/lib/components/VHover';
import { VImg } from 'vuetify/lib/components/VImg';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VHover, {
    attrs: {
      "open-delay": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function ({
        hover
      }) {
        return [_c(VCard, {
          staticClass: "mx-auto fav-dtwin-card grey-border",
          style: _vm.tileSizeSetting == 1 ? 'height: 482px; max-height: 482px;' : 'height: 340px; max-height: 340px;',
          attrs: {
            "elevation": hover ? 4 : 0,
            "min-width": "240",
            "outlined": ""
          },
          on: {
            "click": function ($event) {
              return _vm.pushToRouter(`/fm-add-ticket`);
            }
          }
        }, [_c('div', {
          staticStyle: {
            "height": "153px"
          }
        }, [_c(VImg, {
          staticClass: "mt-8 align-end",
          attrs: {
            "src": "./img/firstSteps/puzzle-pieces.svg",
            "height": "135px",
            "contain": ""
          }
        })], 1), _c(VCardText, {
          class: `fav-tiles${_vm.dsize} pt-0 mt-2`
        }, [_c('markdown-it-vue-light', {
          attrs: {
            "content": _vm.$i18n_t('Common.fmTicketsAddHeadInfoText')
          }
        })], 1)], 1)];
      }
    }])
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };